import { render } from "./XmlRemark.vue?vue&type=template&id=7bc574c6&scoped=true"
import script from "./XmlRemark.vue?vue&type=script&lang=js"
export * from "./XmlRemark.vue?vue&type=script&lang=js"

import "./XmlRemark.vue?vue&type=style&index=0&id=7bc574c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc574c6"]])

export default __exports__